import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ISignatureMoment } from "../signatureMomentModel";

export const getAllSignatureMoments = createAsyncThunk(
  "SignatureMoments/FindAllSignatureMoments",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SignatureMoments/FindAllSignatureMoments`,
        {
          Title: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Signature Moment:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createSignatureMoment = createAsyncThunk(
  "SignatureMoments/InsertSignatureMoments",
  async (SignatureMomentData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SignatureMoments/InsertSignatureMoments`,
        SignatureMomentData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Signature Moment:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateSignatureMoment = createAsyncThunk(
  "SignatureMoments/UpdateSignatureMoments",
  async (SignatureMomentData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SignatureMoments/UpdateSignatureMoments`,
        SignatureMomentData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Signature Moment:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteSignatureMoment = createAsyncThunk(
  "SignatureMoments/DeleteSignatureMoments",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SignatureMoments/DeleteSignatureMoments`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Signature Moment :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getSignatureMomentByID = createAsyncThunk(
  "SignatureMoments/FindByIDSignatureMoments",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SignatureMoments/FindByIDSignatureMoments`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Image: result.Image,
        Tag: result.Tag,
        SequenceNo: result.SequenceNo,
        IsActive: result.IsActive ? 1 : 2,
      } as ISignatureMoment;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Signature Moment :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveSignatureMoments = createAsyncThunk(
  "SignatureMoments/FindAllActiveSignatureMoments",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/SignatureMoments/FindAllActiveSignatureMoments`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Signature Moment:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveSignatureMoment = createAsyncThunk(
  "SignatureMoments/ActiveInActiveSignatureMoments",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SignatureMoments/ActiveInActiveSignatureMoments`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Signature Moment :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const SignatureMomentImageUpload = createAsyncThunk(
  "SignatureMoments/SignatureMomentsImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SignatureMoments/SignatureMomentsImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Signature Moment Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
